import { ReactNode } from 'react';
import { MARKS } from '@contentful/rich-text-types';
/*
 *  Renders markup from contentful input
 */
export const renderMarkup = {
    [MARKS.BOLD]: (text: ReactNode) => <strong key={`${text}`}>{text}</strong>,
    [MARKS.ITALIC]: (text: ReactNode) => <em key={`${text}`}>{text}</em>
};

/*
 *  Determines if the link is external, returns TRUE if... true
 */
export function isExternalUri(str: string): boolean {
    return /^https?:\/\/(?!www\.zoopla\.co\.uk\/)/.test(str);
}
